import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

// Opens the "new" dialog prefilled with ?koy=<id> when ?yeni=1, and returns to ?geri after saving.
export function useQuickAdd(onOpen, open) {
  const [params, setParams] = useSearchParams();
  const navigate = useNavigate();
  const backRef = useRef(null);
  const prevOpen = useRef(open);

  useEffect(() => {
    const village = params.get("koy");
    if (params.get("yeni") === "1" && village) {
      const back = params.get("geri");
      backRef.current = back && back.startsWith("/koyler/") ? back : null;
      onOpen(village);
      setParams({}, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (prevOpen.current && !open) {
      backRef.current = null;
    }
    prevOpen.current = open;
  }, [open]);

  return () => {
    if (backRef.current) navigate(backRef.current);
  };
}
